module.exports = __webpack_public_path__ + "media/images/stock_groups/f1f3-8a763a7eb642e444c73d32313603b8f3.svg";